module.exports = __webpack_public_path__ + "static/media/lumibeam-2.38216fbd.jpg";